
import React, { useState } from 'react'

import { removeInternalProfile, removeResponsible } from '@/Services/ProgrammationManagerService';
import { useProgrammation } from '@/Hooks/UseProgrammation';

import UserAvatar from '@/Components/UserAvatar/UserAvatar';

import Spinner from '@/Components/SvgImages/Spinner/Spinner';
import TrashIcon from '../../SvgImages/TrashIcon';

import { useDispatch } from 'react-redux';
import { updateResponsiblesAction } from '@/Redux/Actions/ProgrammationManagerActions';

import './ResponsibleItem.scss'

interface Props {
  profile: any
  subTask?: any
  canDelete?: boolean
  onDeleted: () => void
}

const InternalProfileItem = ({ profile, subTask, canDelete = true, onDeleted }: Props) => {

  const { itemOpened, setEditingItem, patchItemOpened } = useProgrammation()

  const dispatch = useDispatch()

  const [ deleting, setDeleting ] = useState(false)

  const task = subTask || itemOpened

  const handleDelete = async () => {

    setEditingItem(true)
    setDeleting(true)

    const [ error, data ] = await removeInternalProfile(task._id, profile._id)

    setDeleting(false)
    setEditingItem(false)

    if (error) {
      return console.log(error)
    }

    if (!subTask) {

      patchItemOpened({
        internalProfiles: itemOpened.internalProfiles.filter((u: any) => u._id !== profile._id)
      })
    } else {

      const subTasks = itemOpened.subTasks

      subTasks.forEach((subTask: any) => {

        if (subTask._id === task._id) {

          subTask.internalProfiles = subTask.internalProfiles.filter((u: any) => u._id !== profile._id)
        }
      })

      patchItemOpened({
        subTasks
      })
    }

    dispatch(updateResponsiblesAction({ task: data.task, parentTask: data.parentTask }))

    onDeleted()
  }

  return (
    <div className="responsible-item">
      <div className="responsible-item-avatar">
        <UserAvatar user={profile} size="sm" />
      </div>
      <div className="responsible-item-content">
        <div className='user-names'>
          {profile.name} {profile.surname}
        </div>
        <div className='profile-of'>
          Perfil interno de {profile.responsible.name} {profile.responsible.surname}
        </div>
      </div>
      <div className="responsible-item-actions">
        {canDelete && (
          <button
            className="responsible-item-delete"
            onClick={handleDelete}
            disabled={deleting}
            >
            {deleting && (
              <Spinner
                height={20}
                width={20}
              />
            )}
            {!deleting && (
              <TrashIcon
                height={20}
                width={20}
                color="#333"
              />
            )}
          </button>
        )}
      </div>
    </div>
  )
}

export default InternalProfileItem
